import { render } from "./carruselfina.vue?vue&type=template&id=6669bd0f&scoped=true"
import script from "./carruselfina.vue?vue&type=script&lang=js"
export * from "./carruselfina.vue?vue&type=script&lang=js"

import "./carruselfina.vue?vue&type=style&index=0&id=6669bd0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6669bd0f"]])

export default __exports__